import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TerritoryService } from 'src/app/services/geolocation/territory.service';
import { ImageManager } from 'src/app/shared/image-manager';
import { Territory } from 'src/app/shared/object/xplorer-be-parsed-classes';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'xplorer-bowser-territory',
    templateUrl: './territory.component.html',
    styleUrls: ['./territory.component.css']
})
export class TerritoryComponent implements OnInit {
  protected readonly ImageManager = ImageManager;
  protected readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  availableTerritories: Territory[] = environment.AVAILABLE_TERRITORY;
  currentTerritoryCode: string | null = null;

  private router: Router = inject(Router);
  private territoryService: TerritoryService = inject(TerritoryService);


  ngOnInit(): void {
    if (this.isBrowser) {
      this.currentTerritoryCode = this.territoryService.getTerritoryCodeFromUrl();
    }
  }

  goToXplorerTerritory(territory: Territory) {
    if (territory.code === this.territoryService.getTerritoryCodeFromUrl()) {
      this.router.navigate(['/explore']);
      return;
    }

    if (environment.IS_LOCAL) {
      this.territoryService.setActiveTerritory(territory.code);
      window.location.href = `${environment.FRONTEND_BASE_URL}/explore`;
    } else {
      window.location.href =
        environment.FRONTEND_BASE_URL.replace('://', '://' + territory.code + '.');
    }
  }

  getTerritoryBackground(territoryCode: string): string {
    return `/assets/xplorer/${territoryCode}/bg_territory_home.webp`;
  }
}
